/**
 * The content a brand-new flow (or blank template) starts with. The API's
 * copy-dsl.ts mirrors this for copying a flow that has no saved version.
 */
export function starterFlowDsl(flowId: string, name: string) {
  return {
    schemaVersion: '1.0',
    id: flowId,
    name,
    variables: { global: [], session: [] },
    nodes: [
      {
        id: 'start',
        type: 'Start',
        label: 'Start',
        next: 'page-1',
        position: { x: 100, y: 120 },
      },
      {
        id: 'page-1',
        type: 'Page',
        label: 'First Page',
        title: 'First Page',
        content: '',
        layoutType: 'single-column',
        contactMenu: {
          enableCallNow: false,
          enableCallReturn: false,
          enableEmail: false,
        },
        elements: [],
        position: { x: 360, y: 120 },
      },
    ],
  };
}
